import FacturesVentesTab from "@features/comptabilite/components/factures/FacturesVentesTab";
import { createFileRoute } from "@tanstack/react-router";
import { Receipt } from "lucide-react";

export const Route = createFileRoute("/_app/comptabilite/factures-ventes/")({
  staticData: {
    title: "Factures ventes",
    icon: Receipt,
    tab_icon: Receipt,
    module: "comptabilite",
    order: 20,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
  },
  component: FacturesVentesTab,
});
